import { useEffect } from 'react';

interface DocumentMeta {
  title: string;
  description?: string;
  keywords?: string;
}

const setMetaTag = (name: string, content: string) => {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
};

export function useDocumentMeta({ title, description, keywords }: DocumentMeta) {
  useEffect(() => {
    document.title = title;
    if (description) setMetaTag('description', description);
    if (keywords) setMetaTag('keywords', keywords);
  }, [title, description, keywords]);
}